module.exports = __webpack_public_path__ + "img/earth.255fa589.jpg";